import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * Captures ?ref= URL parameter into localStorage.
 * Runs at App level so referral attribution is captured on any route.
 * Does NOT remove existing ref if URL lacks ?ref= (preserves prior attribution).
 * Does NOT strip ?ref= from URL (shareable links work).
 *
 * ref_sol removed — short code resolves to both EVM and Solana addresses server-side.
 */
export function useReferralCapture() {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const ref = searchParams.get('ref')
    if (ref) {
      localStorage.setItem('parsebridge:ref', ref)
    }
  }, [searchParams])
}
